import { useQuery } from '@tanstack/react-query';
import type { TailscaleNetworkInfoSchema } from '@terra/shared-contracts-connector-manager';
import { connectorManagerClient } from '@terra/shared-rest-clients-connector-manager';
import type { z } from 'zod';
import {
  createApiHeaders,
  withOrchestratorClient,
} from '../../clients/tester-client/api-core';

const QUERY_KEY = 'query.internal-access-networks';
const EMPTY_NETWORKS: InternalAccessNetworkDto[] = [];

export type InternalAccessNetworkDto = z.infer<
  typeof TailscaleNetworkInfoSchema
>;

export const useInternalAccessNetworks = ({
  enabled = true,
}: { enabled?: boolean } = {}) => {
  const { data, isLoading, isError, error, refetch, isFetched } = useQuery({
    queryKey: [QUERY_KEY],
    queryFn: async () => {
      const headers = await createApiHeaders();
      const { status, body } =
        await connectorManagerClient.listInternalAccessNetworks({
          ...withOrchestratorClient(headers),
        });

      if (status !== 200) {
        throw new Error('Failed to fetch internal access networks');
      }

      return body.result.filter((network) => network.isActive);
    },
    enabled,
  });

  return {
    networks: data ?? EMPTY_NETWORKS,
    isLoading,
    isError,
    error,
    refetch,
    isFetched,
  };
};
